import { UIFlightData } from "@flights/types";
import { createTrackingUtils } from "..";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_fare_rules_aa_legs_diff",
  defaultStage: 1,
  stages: {
    fd_with_fare_rules: 1,
    change_diff: 2,
    cancel_diff: 3,
    change_cancel_diff: 4
  },
  goals: {
    operated_1_arline: 1,
    operated_2_arlines: 2,
    operated_3_arlines: 3,
    is_owc: 4
  }
});

export const useTrackFareRulesAADiff = (flight: UIFlightData) => {
  useEffect(() => {
    const data = Array.isArray(flight.fareRules) ? flight.fareRules : flight.fareRules?.perSegment || [];

    if (!data.length) return;

    utils.stages.fd_with_fare_rules();

    let changeDiffer = false;
    let cancelDiffer = false;

    const availableFareRulesMap: Partial<
      Record<"CHANGE" | "CANCEL", { units: number | undefined; nanos: number | undefined }>
    > = {};

    for (const segment of data) {
      if (segment.availablePolicies) {
        for (const policy of segment.availablePolicies) {
          if (policy.type.includes("CHANGE")) {
            const units = policy.priceBreakdown?.total.units;
            const nanos = policy.priceBreakdown?.total.nanos;

            if (availableFareRulesMap.CHANGE) {
              if (availableFareRulesMap.CHANGE.units !== units || availableFareRulesMap.CHANGE.nanos !== nanos) {
                changeDiffer = true;
              }
            } else {
              availableFareRulesMap.CHANGE = {
                units,
                nanos
              };
            }
          }

          if (policy.type.includes("CANCEL")) {
            const units = policy.priceBreakdown?.total.units;
            const nanos = policy.priceBreakdown?.total.nanos;

            if (availableFareRulesMap.CANCEL) {
              if (availableFareRulesMap.CANCEL.units !== units || availableFareRulesMap.CANCEL.nanos !== nanos) {
                cancelDiffer = true;
              }
            } else {
              availableFareRulesMap.CANCEL = {
                units,
                nanos
              };
            }
          }
        }
      }

      if (segment.unavailablePolicies) {
        for (const unavailablePolicy of segment.unavailablePolicies) {
          if (unavailablePolicy.type.includes("CHANGE") && availableFareRulesMap.CHANGE) {
            changeDiffer = true;
          }

          if (unavailablePolicy.type.includes("CANCEL") && availableFareRulesMap.CANCEL) {
            cancelDiffer = true;
          }
        }
      }
    }

    if (changeDiffer) {
      utils.stages.change_diff();
    }

    if (cancelDiffer) {
      utils.stages.cancel_diff();
    }

    if (changeDiffer && cancelDiffer) {
      utils.stages.change_cancel_diff();
    }

    const { size } = new Set(
      flight.segments.flatMap((s) => s.legs.flatMap((l) => l.flightInfo.carrierInfo?.operatingCarrier)).filter(Boolean)
    );

    if (size === 1) {
      utils.goals.operated_1_arline();
    }

    if (size === 2) {
      utils.goals.operated_2_arlines();
    }

    if (size === 3) {
      utils.goals.operated_3_arlines();
    }

    if (flight.oneWayCombination) {
      utils.goals.is_owc();
    }
  }, [flight.fareRules, flight.oneWayCombination, flight.segments]);
};

export default utils;
